module.exports = __webpack_public_path__ + "img/welfare-item-bg.bac143af.png";